<template>
    <div class="w-full text-[var(--text)] gap-2 p-4 bg-[var(--fundoApp)] rounded-[10px] bg-opacity-[0.55] flex flex-col">

        <!-- <GenericIdentity -->
        <Proposta
            :data="{
                entity:'faturafornecedor',
            }" 
                
            @saved_items="saveItemns"
            :fornecedor_id="propsData.fornecedor_id"
            :models="{
                equipamento:{
                    quantidade:0,
                    subTotal:0,
                    desconto:0,
                    valorTotal:0,
                },
                servico:{
                    quantidade:0,
                },
                db_model:{
                    quantidade:0,
                    faturaFornecedor_id:0,
                    desconto:0,
                    valorUnitario:0,
                    subTotal:0,
                    valorTotalComIva:0,
                    valorTotal:0,
                    tpIva_id:5,
                    equipamento_id:0,
                },

                faturafornecedor:{
                    stock: 0,
                    subTotal: 0,
                    total: 0,
                    //    armazem_fornecedor_id: 0,
                    valorTotalComIva:0,
                    desconto: 0,
                    tpMoeda_id: 0,
                    tpIva_id: 5,
                    fornecedor_id: this.propsData.fornecedor_id,
                },
            }"

            :types="{
                moeda:moedas,
                iva:ivas,
            }"
            :set_data="{
                moeda:{id:0,nome:'N/A'},
                iva:{id:0,nome:'N/A'},
            }"
            :set_id="{
                moeda:'tpMoeda_id',
                iva:'tpIva_id',
            }"
            
            @close="closeGenericIdentity"
            
        />

    </div>

</template>


<script>
    import GenericIdentity from '@/components/genericIdentity.vue'
    import axios from 'axios'
    import AppButton from '@/components/button.vue'
    import AppTable from '@/components/tables/table.vue'
    import Proposta from '@/components/forms/fornecedor/faturaFornecedor.vue';
    export default {
        name: 'encomenda',
        components: {
            AppButton,
            AppTable,
            GenericIdentity,
            Proposta,
        },
        props: {
            propsData: {
                type: Object,
                default: () => ({
                    fornecedor_id: 0,
                    other_test: 'nothonig'
                }),
            },
            entities: {
                type: Array,
                default: () => [
                    {
                        nome: '',
                        id: 0
                    },
                    {
                        id: 0,
                        numero: '',
                    }
                ]
            },  
        },
        data() {
            return {
                baseURl: process.env.VUE_APP_URL_BASE,
                atualFatura_id: 1,
                model: {
                   fornecedor_id:0,
                   numero: '',
                   recolha_id: 0,
                   entrega_id: 0,
                   data: '',
                   
                   moeda_id: 0,
                   iva_id: 0,
                   prazo_id: 0,
                   
                   total: 0,
                  
                   status: '',
                },
                item_fatura_model:{
                    fatura_id: 0,
                    equipamento_id: 0,
                    quantidade: 0,
                    preco: 0,
                    obervacao: '',
                    status: '',
                },
                moedas:[],
                equipamentos:[],
                ivas: [],
                prazos: [],
                
            };
        },
        computed : {
           /* 
                equipamentos() {
                  return this.equipamentos.map(item => {
                    const { id, equipamento_nome, produto, ...rest } = item;
                    return {
                        id,
                      ...rest,
                    };
                  });
                }
            */

        },

        saveItemns(data){
            console.log("Data received on saveItems:", data);
        },

        async created() {
            this.moedas= await this.select_all(`${this.baseURl}/api/v1/tpmoeda/`);
            // this.equipamentos= await this.select_all(`${this.baseURl}/api/v1/equipamento/?custom=1`);
            this.ivas= await this.select_all(`${this.baseURl}/api/v1/tpiva/`);
            // this.prazos= await this.select_all(`${this.baseURl}/api/v1/tpprazo/`);
            console.log("Props RECEIVED ON FATURACAO:", this.propsData);
            
            
        },
        methods: {

            closeGenericIdentity() {
                this.$emit('close');
            },
            
            close() {
                // this.$emit('close');
            },
        //     async create(data, url) {
        //       try {
        //           const res = await axios.post(url, data);
        //           return res.data.data;
        //       } catch (error) {
        //           console.error('Error getting data:', error);
        //       }
        //     },
  
        // async select(url) {
        //     try {
        //         const res = await axios.get(url);
        //         return res.data.data;
        //     } catch (error) {
        //         console.error('Error getting data:', error);
        //     }
        // },
    
        async select_all(url) {
            try {
                const res = await axios.get(url);
                return res.data.data;
    
            } catch (error) {
                console.error('Error getting data:', error);
            }
    
        },
    
        // async update(url, data) {
    
        //     try {
        //         const res = await axios.put(url, data);
        //         console.log('Data successfully updated:', res.data);
        //         return res.data.data;
    
        //     } catch (error) {
        //         console.error('Error posting data:', error);
        //     }
        // },
    
        // async remove(url) {
        //     // console.log("Data:", data.id)
        //     try {
        //         await axios.delete(url);
        //         return true;
        //     } catch (error) {
        //         console.error('Error deleting data:', error);
        //     }
        // },
            
        }
    }

</script>



<style scoped>


</style>